import React, { useState } from 'react';
import { colorSet } from '@theme';

interface IconProps {
  style?: React.CSSProperties;
  onClick?: () => void;
}

// 이미지 상세페이지(모달)의 작품명 검색 아이콘
// default: width height 24 & color:gray400
// hover: width height 26.4 & color:primary
export const ComicNameSearchIcon: React.FC<IconProps> = ({ style, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  const currentWidth = isHovered ? 26.4 : 24;
  const currentHeight = isHovered ? 26.4 : 24;
  const currentColor = isHovered ? colorSet.primaryMain : colorSet.gray400;

  return (
    <svg
      width={currentWidth}
      height={currentHeight}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ ...style, color: currentColor, cursor: onClick ? 'pointer' : 'default' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <path
        d="M10.5 2C15.2 2 19 5.8 19 10.5C19 12.4999 18.3001 14.3998 17.2002 15.7998L21.7002 20.2998C22.1002 20.6998 22.1002 21.3002 21.7002 21.7002C21.5002 21.9002 21.2 22 21 22C20.8 22 20.4998 21.9002 20.2998 21.7002L15.7998 17.2002C14.2998 18.3001 12.4999 19 10.5 19C5.8 19 2 15.2 2 10.5C2 5.8 5.8 2 10.5 2ZM10.5 4C6.9 4 4 6.9 4 10.5C4 14.1 6.9 17 10.5 17C12.3 17 13.8996 16.2996 15.0996 15.0996C16.2996 13.8996 17 12.3 17 10.5C17 6.9 14.1 4 10.5 4Z"
        fill="currentColor"
      />
      <mask
        id="mask0_6264_3251"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="21"
        height="20"
      >
        <path
          d="M10.5 2C15.2 2 19 5.8 19 10.5C19 12.4999 18.3001 14.3998 17.2002 15.7998L21.7002 20.2998C22.1002 20.6998 22.1002 21.3002 21.7002 21.7002C21.5002 21.9002 21.2 22 21 22C20.8 22 20.4998 21.9002 20.2998 21.7002L15.7998 17.2002C14.2998 18.3001 12.4999 19 10.5 19C5.8 19 2 15.2 2 10.5C2 5.8 5.8 2 10.5 2ZM10.5 4C6.9 4 4 6.9 4 10.5C4 14.1 6.9 17 10.5 17C12.3 17 13.8996 16.2996 15.0996 15.0996C16.2996 13.8996 17 12.3 17 10.5C17 6.9 14.1 4 10.5 4Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_6264_3251)"></g>
    </svg>
  );
};
